export const DEFAULT_VOICE_DATA_FOR_REGISTER = {
  VOICE_ID: "af_alloy",
  VOICE_LANG: "ENGLISH",
}

export const PRIVACY_POLICY_URL = "https://frateca.com/privacy-policy"
export const TERMS_OF_SERVICE_URL = "https://frateca.com/terms-of-service"
export const RESTORE_PURCHASES_URL = "mailto:support@frateca.com"

export const SUPPORT_EMAIL = "support@frateca.com"
